import { messagesNow } from '@/i18n'
import { messages } from './messages'

// Подписи — только полей формы статьи; незнакомое поле — сырым именем, без угаданного
// перевода. `Map`, а не литерал: ключ `constructor` у литерала вернул бы функцию.
const fieldLabels = () => {
  const m = messagesNow(messages)
  return new Map([
    ['title', m.fieldTitle],
    ['content', m.fieldContent],
    ['titleEn', m.fieldTitleEn],
    ['contentEn', m.fieldContentEn],
  ])
}

/** Подпись поля формы статьи; незнакомое поле — сырым именем. */
export const fieldLabel = (field: string): string => fieldLabels().get(field) ?? field

/** Pydantic-отказ `{detail: [{loc, msg}]}`: первое поле и сообщение сервера дословно. */
const validationText = (detail: unknown): string | null => {
  if (!Array.isArray(detail) || detail.length === 0) return null
  const first = detail[0] as { loc?: unknown; msg?: unknown }
  if (typeof first?.msg !== 'string') return null
  const loc = Array.isArray(first.loc) ? first.loc : []
  const field = String(loc[loc.length - 1] ?? '')
  return messagesNow(messages).fieldRejected(fieldLabel(field), first.msg)
}

const styleFieldText = () => {
  const m = messagesNow(messages)
  return new Map([
    ['gradient', m.styleGradient],
    ['titleColor', m.styleTitleColor],
    ['borderColor', m.styleBorderColor],
  ])
}

/** `422 invalid_style_value`: текст по полю оформления, которое сервер не принял. */
export const styleText = (detail: object): string => {
  const field = (detail as { field?: unknown }).field
  return (
    (typeof field === 'string' ? styleFieldText().get(field) : undefined) ??
    messagesNow(messages).styleInvalid
  )
}

const codeText = (detail: unknown): string | null => {
  if (typeof detail !== 'object' || detail === null || !('code' in detail)) return null
  const code = (detail as { code?: string }).code
  const m = messagesNow(messages)
  if (code === 'published') return m.published
  if (code === 'article_in_use') return m.articleInUse
  if (code === 'invalid_style_value') return styleText(detail)
  if (code === 'unique_error') return m.uniqueError
  return null
}

const detailOf = (data: unknown): unknown =>
  typeof data === 'object' && data !== null && 'detail' in data
    ? (data as { detail?: unknown }).detail
    : undefined

const isNetworkError = (err: unknown): boolean => {
  const status = (err as { status?: unknown } | null)?.status
  return status === 'FETCH_ERROR' || status === 'TIMEOUT_ERROR'
}

export const errorMessage = (err: unknown): string => {
  const m = messagesNow(messages)
  // Ручки статьи молчат в `errorToastMiddleware`, и обрыв сети объясняет только этот текст.
  if (isNetworkError(err)) return m.network
  if (typeof err === 'object' && err !== null && 'data' in err) {
    const detail = detailOf((err as { data?: unknown }).data)
    const status = (err as { status?: number }).status
    const text = codeText(detail) ?? (status === 422 ? validationText(detail) : null)
    if (text) return text
    if (status === 403) return m.forbidden
    if (status === 404) return m.notFound
  }
  return m.generic
}
